import { Box, TableCell } from '@mui/material';
import styled from 'styled-components';

export const StyledImage = styled('img')({
  width: '100px',
  maxHeight: '60px',
  objectFit: 'contain',
});

export const StyledTableCell = styled(TableCell)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px'
});

export const StyledDrag = styled(Box)`
  position: relative;
  display: flex;
  gap: 20px;
  align-items: center;
`;
